<template>
  <div>
    <!-- Filters -->
    <div class="card">
      <div class="card-body">
        <form>
          <h5 class="card-title">Filtres</h5>
          <div class="row">
            <div class="col-xs-3" style="margin: 10px;">
              <fieldset>
                <label><strong>Inclure les postes</strong></label>
                <div class="radio">
                  <label>
                    <input type="radio" id="filterPositions1" value="requiredOnly" checked
                           v-model="f_positions"
                           v-on:change="refresh">
                    Postes francophones requis seulement
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input type="radio" id="filterPositions2" value="all"
                           v-model="f_positions"
                           v-on:change="refresh">
                    Tous les postes
                  </label>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-9" style="margin: 10px;">
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Breadcrumb -->
    <h5>Ratios d'emplois francophones - <a :href="agencyUrl()" @click="agencyUrlClick()">{{agency_fr}}</a>{{siteName}} ({{period}})</h5>

    <!-- Info Fournisseur -->
    <OnRatiosAgencyInfo :agencyId="agencyId" :period="period" />

    <!-- Total -->
    <OnRatiosEmploisTotal v-if="ratios.length > 1" :ratios="ratios" />

    <!-- Ratios -->
    <h6>Par Position</h6>
    <table class="table table-sm table-bordered">
      <thead>
      <tr style="background-color: #f0f8ff">
        <th></th>
        <OnRatiosTableHeaders1 />
      </tr>
      <tr style="background-color: #f0f8ff">
        <th>Position</th>
        <OnRatiosTableHeaders2 />
      </tr>
      </thead>
      <tbody>
      <tr v-for="(r, i) in ratios" :key="i">
        <td>{{r.position_title}}</td>
        <OnRatiosTableCells :row="r" />
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import OnRatiosAgencyInfo from "@/components/OnRatiosAgencyInfo";
import OnRatiosEmploisTotal from '@/components/OnRatiosEmploisTotal.vue';
import OnRatiosTableHeaders1 from "@/components/OnRatiosTableHeaders1";
import OnRatiosTableHeaders2 from "@/components/OnRatiosTableHeaders2";
import OnRatiosTableCells from "@/components/OnRatiosTableCells";
import axios from 'axios';

export default {
  name: 'OnRatiosEmploisSite',
  components: {
    OnRatiosAgencyInfo,
    OnRatiosEmploisTotal,
    OnRatiosTableHeaders1,
    OnRatiosTableHeaders2,
    OnRatiosTableCells
  },
  props: {
    agencyId : String,
    pointServicesId : String,
    period: String
  },
  data() { return {
    f_positions: 'requiredOnly',
    agency_fr: '',
    point_services_fr: '',
    ratios: []
  }},
  computed: {
    siteName() {
      let result = '';
      if (this.point_services_fr) {
        result += (' >> ' + this.point_services_fr);
      }

      return result;
    }
  },
  methods: {
    agencyUrl() {
      return '/on/ratiosemplois/' + this.agencyId;
    },
    agencyUrlClick() {
      this.$router.push(this.agencyUrl);
      return false;
    },
    getPointServiceInfo() {
      axios
          .get(
              this.$root.$data.server_base + '/api/on/point_service_svc.php',
              {
                params: {
                  agency_id : this.agencyId,
                  point_services_id : this.pointServicesId,
                  period : this.period
                }
              }
          ).then(rsp => {
        this.agency_fr = rsp.data.agency_fr;
        this.point_services_fr = rsp.data.point_services_fr;
      });
    },
    refresh() {
      axios
          .get(
              this.$root.$data.server_base + '/api/on/ratios_emplois_site.php',
              {
                params: {
                  agency_id : this.agencyId,
                  point_services_id : this.pointServicesId,
                  period: this.period,
                  positions: this.f_positions
                }
              }
          ).then(rsp => {
        this.ratios = rsp.data.ratios;
      });
    }
  },
  mounted() {
    this.getPointServiceInfo();
    this.refresh();
  }
}

</script>